module.exports = __webpack_public_path__ + "img/Israel.171fcb0c.svg";